import { useEffect } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { SOCKET_EVENT } from "../../../common/utils/consts";
import { createSocket } from "../../../services/socket";
import { supportApi } from "../../../services/supportApi";

const CHANNEL = "private-support";

/** Пауза, чтобы пачку сообщений (сокет-сервер досылает накопленное при подключении) обновить одним запросом */
const REFRESH_DELAY_MS = 300;

/**
 * Живые обновления чатов поддержки: канал сотрудников private-support. Событие несёт
 * само сообщение, но список обращений (счётчики, порядок) и открытая переписка проще
 * перечитать, чем править кэш — запросы лёгкие, а состояние всегда с сервера
 */
export function useSupportSocket() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const socket = createSocket();
    let timer: ReturnType<typeof setTimeout> | undefined;

    const refresh = () => {
      if (timer) return;
      timer = setTimeout(() => {
        timer = undefined;
        dispatch(
          supportApi.util.invalidateTags([
            { type: "SupportTicket", id: "LIST" },
            "SupportMessages",
          ])
        );
      }, REFRESH_DELAY_MS);
    };

    // При каждом (пере)подключении: подписка заново и догон пропущенного
    socket.on("connect", () => {
      socket.emit("subscribe", { channel: CHANNEL });
      refresh();
    });

    // Без подтверждения доставки сервер досылает событие до пяти раз
    socket.on(
      SOCKET_EVENT.SUPPORT_MESSAGE_CREATED,
      (_data: unknown, ack?: unknown) => {
        if (typeof ack === "function") ack(true);
        refresh();
      }
    );

    return () => {
      if (timer) clearTimeout(timer);
      socket.emit("unsubscribe", { channel: CHANNEL });
      socket.disconnect();
    };
  }, [dispatch]);
}
